import { Company } from "./company.model"
import { DeviceLatestStatus } from "./device-latest-status.model"

export class Device {
    public id?: string
    public time?: Date
    public firmware: string
    public model: string
    public periot: string
    public shakeCount: string
    public sonicActive: string
    public sonicFilte: string
    public sonicTolerans: string
    public sonicMeasure: string
    public msgTyr: string
    public msgStanby: string
    public runType: string
    public gpsRepeat: string
    public gpsTime: string
    public gpsPeriot: string
    public shakeWait: string
    public distanceTime:string
    public empty1:string
    public empty2:string
    public empty3:string
    public distanceValue:string
    public batMin: string
    public batGpMin: string
    public batMultiplier: string
    public solarMultiplier: string
    public serialNumber: string
    public apn: string
    public hostRequestWeb: string
    public hostRequestEXT: string
    public ssid: string
    public smsNumber: string
    public periotTimeOut: string
    public heatAlarm?: string
    public updated?: number
    public uDate?: Date
    public companyId?: number
    public status?:boolean
    public firmwareUpdateCheck?:boolean
    public demoMode?:boolean

    public company?:Company
    public deviceLatestStatus?:DeviceLatestStatus
}